import { render } from "./FridgeDetailsSelectButtons.vue?vue&type=template&id=06eff826&scoped=true&ts=true"
import script from "./FridgeDetailsSelectButtons.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsSelectButtons.vue?vue&type=script&lang=ts"

import "./FridgeDetailsSelectButtons.vue?vue&type=style&index=0&id=06eff826&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eff826"]])

export default __exports__